module.exports = __webpack_public_path__ + "staticesp/media/marcas (1).228223c9.jpg";